import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  organizations: [],
  organizationsStatus: IDLE,

  selectedOrganizationId: null,

  createOrganizationStatus: IDLE,
  updateOrganizationStatus: IDLE,
  bulkEditOrganizationsStatus: IDLE,

  insuranceOrganizationLogos: {}
};

const organizationsSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    getOrganizations(state) {
      state.organizationsStatus = LOADING;
    },
    getOrganizationsSucceeded(state, action) {
      state.organizationsStatus = SUCCEEDED;
      state.organizations = action.payload;
    },
    getOrganizationsFailed(state) {
      state.organizationsStatus = FAILED;
    },

    setSelectedOrganizationId(state, action) {
      state.selectedOrganizationId = action.payload?.organizationId;
    },

    createOrganization(state) {
      state.createOrganizationStatus = LOADING;
    },
    createOrganizationSucceeded(state) {
      state.createOrganizationStatus = SUCCEEDED;
    },
    createOrganizationFailed(state) {
      state.createOrganizationStatus = FAILED;
    },

    updateOrganization(state) {
      state.updateOrganizationStatus = LOADING;
    },
    updateOrganizationSucceeded(state) {
      state.updateOrganizationStatus = SUCCEEDED;
    },
    updateOrganizationFailed(state) {
      state.updateOrganizationStatus = FAILED;
    },

    bulkEditOrganizations(state) {
      state.bulkEditOrganizationsStatus = LOADING;
    },
    bulkEditOrganizationsSucceeded(state) {
      state.bulkEditOrganizationsStatus = SUCCEEDED;
    },
    bulkEditOrganizationsFailed(state) {
      state.bulkEditOrganizationsStatus = FAILED;
    },

    setInsuranceOrganizationLogos(state, action) {
      state.insuranceOrganizationLogos = action.payload;
    }
  }
});

export const {
  getOrganizations,
  getOrganizationsSucceeded,
  getOrganizationsFailed,
  setSelectedOrganizationId,
  createOrganization,
  createOrganizationSucceeded,
  createOrganizationFailed,
  updateOrganization,
  updateOrganizationSucceeded,
  updateOrganizationFailed,
  bulkEditOrganizations,
  bulkEditOrganizationsSucceeded,
  bulkEditOrganizationsFailed,
  setInsuranceOrganizationLogos
} = organizationsSlice.actions;

export default organizationsSlice.reducer;
